import React, { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { getEnv } from 'common/selectors/env';
import { AnalyticsPageMeta } from 'features/analytics';
import { Remote } from '@okapi/remote';
import { Layout } from 'fronton-react';
import { BreadcrumbsSection } from 'features/breadcrumbs';
import { SeoDescriptionSection } from 'features/seo-description';

type Props = {
  children: ReactNode;
};

export const MainLayout: FC<Props> = ({ children }) => {
  const { USE_APPSFLYER } = useSelector(getEnv);

  return (
    <>
      <AnalyticsPageMeta />
      <Remote
        widget="header-footer/header"
        id="store-list-header"
        data={{ disableAppsflyer: !USE_APPSFLYER }}
      />
      <Layout>
        <BreadcrumbsSection />
        {children}
        <SeoDescriptionSection />
      </Layout>
      <Remote widget="header-footer/footer" id="store-list-footer" />
    </>
  );
};
